import React from "react";
import Moment from "react-moment";

import { v4 as uuidv4 } from "uuid";

import ZeeTable from "components/ZeeTable";

import DropZone from "./DropZone";

import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import Avatar from "@material-ui/core/Avatar";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import FolderIcon from "@material-ui/icons/Folder";
import IconButton from "@material-ui/core/IconButton";

import ImageIcon from "@material-ui/icons/Image";
import AudiotrackIcon from "@material-ui/icons/Audiotrack";
import MovieIcon from "@material-ui/icons/Movie";
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";
import DescriptionIcon from "@material-ui/icons/Description";

import Header from "./Header";
import Action from "./Action";
import Row from "./Row";

import "./style.scss";

export default class extends React.Component {
  state = {
    folder: this.props.folder || null,
    data: this.props.data || [],
  };

  data() {
    const { folder, data } = this.state;

    const folders = data.filter((item) => item.type === "folder");
    const assets = data.filter((item) => item.type !== "folder");

    return [
      ...folders.filter((item) => item.parent === folder),
      ...assets.filter((item) => item.parent === folder),
    ];
  }

  folders() {
    const folders = [];
    const { data, folder } = this.state;

    const recursiveFolderFind = (folder, folders) => {
      folders.unshift(folder);

      if (folder.parent) {
        const _folder = data.find((item) => item.id === folder.parent);

        if (_folder) {
          recursiveFolderFind(_folder, folders);
        }
      }
    };

    if (folder) {
      const _folder = data.find((item) => item.id === folder);
      recursiveFolderFind(_folder, folders);
    }

    folders.unshift({
      id: null,
      name: "File explorer",
    });

    return folders;
  }

  async onEdit(row) {
    let { data } = this.state;

    const onEdit = this.props.onEdit || null;
    if (onEdit) {
      const result = await onEdit(row);
      if (result) {
        data = data.map((item) =>
          item.id === row.id ? { ...row, ...result } : item
        );
      } else {
        return false;
      }
    } else {
      data = data.map((item) => (item.id === row.id ? row : item));
    }

    this.setState({
      data,
    });

    return true;
  }

  async onDelete(row) {
    let { data } = this.state;

    const onDelete = this.props.onDelete || null;
    if (onDelete) {
      const result = await onDelete(row);
      if (result) {
      } else {
        return false;
      }
    }

    data = data.reduce(
      (agg, item) => (item.id === row.id ? agg : [...agg, item]),
      []
    );

    this.setState({
      data,
    });

    return true;
  }

  async onCreateFolderClick() {
    const { folder, data } = this.state;
    const onCreateFolder = this.props.onCreateFolder || null;

    const asset = {
      id: uuidv4(),
      parent: folder,
      type: "folder",
      name: "New folder",
      size: 0,
      modified: Math.round(new Date().getTime() / 1000),
    };

    let result = {};
    if (onCreateFolder) {
      result = await onCreateFolder(asset);
      if (!result) {
        return false;
      }
    }

    this.setState({
      data: [...data, { ...asset, ...result }],
    });
  }

  onUploadClick() {}

  onRowDoubleClick(row) {
    if (row.type === "folder") {
      this.setState({
        folder: row.id,
      });
    }
  }

  onBreadcrumbClick(folder) {
    this.setState({
      folder: folder.id,
    });
  }

  onSelected(row) {
    if (row.type === "folder") {
      return false;
    }

    return true;
  }

  onFileProgress(file, progress) {
    const data = this.state.data.map((item) => {
      if (item.id === file.id) {
        return { ...item, progress };
      }
      return item;
    });

    this.setState({
      data,
    });
  }

  onFileUploaded(file, original) {
    if (file) {
      const data = this.state.data.map((item) =>
        item.id === original.id ? file : item
      );

      this.setState({
        data,
      });
    }
  }

  onFileUpload(file, original) {
    const onFileUpload = this.props.onFileUpload || null;

    if (onFileUpload) {
      file.isUploading = true;
      file.progress = 0;

      onFileUpload(file, original, (file, progress) =>
        this.onFileProgress(file, progress)
      ).then((result) => this.onFileUploaded(result, file));
    }

    return file;
  }

  onFilesDrop(files) {
    const { data, folder } = this.state;

    files = files.map((file) => {
      const original = file;
      file = {
        id: uuidv4(),
        name: file.name,
        parent: folder,
        size: file.size,
        type: "unknown",
        modified: Math.round(file.lastModifiedDate / 1000),
      };

      return this.onFileUpload(file, original);
    });

    this.setState({
      data: [...data, ...files],
    });
  }

  render() {
    const data = this.data();
    const folders = this.folders();

    const columns = {
      name: {
        name: "Name",
        format: (name, row) => {
          let icon = null;

          switch (row.type) {
            case "image":
              icon = <ImageIcon />;
              break;
            case "audio":
              icon = <AudiotrackIcon />;
              break;
            case "video":
              icon = <MovieIcon />;
              break;
            case "pdf":
              icon = <PictureAsPdfIcon />;
              break;
            case "folder":
              icon = <FolderIcon />;
              break;
            default:
              icon = <DescriptionIcon />;
          }

          return (
            <span>
              {icon}
              {name}
            </span>
          );
        },
      },
      size: {
        name: "Size",
        noEdit: true,
        format: (bytes) => {
          const si = false;
          const dp = 1;
          const thresh = si ? 1000 : 1024;

          if (Math.abs(bytes) < thresh) {
            return bytes + " B";
          }

          const units = si
            ? ["kB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
            : ["KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"];
          let u = -1;
          const r = 10 ** dp;

          do {
            bytes /= thresh;
            ++u;
          } while (
            Math.round(Math.abs(bytes) * r) / r >= thresh &&
            u < units.length - 1
          );

          return bytes.toFixed(dp) + " " + units[u];
        },
      },
      modified: {
        name: "Last Modified",
        noEdit: true,
        format: (unix) =>
          unix && (
            <Moment unix format="DD/MM/YY HH:mm:ss">
              {unix}
            </Moment>
          ),
      },
    };

    return (
      <div className="zee-explorer">
        <DropZone onFilesDrop={(files) => this.onFilesDrop(files)}>
          <ZeeTable
            title="File explorer"
            columns={columns}
            data={data}
            hasSearch={true}
            hasSort={true}
            hasPagination={true}
            hasEdit={true}
            hasDelete={true}
            hasSelection={true}
            hasMultipleSelection={false}
            hasUpload={true}
            hasCreateFolder={true}
            onEdit={(row) => this.onEdit(row)}
            onDelete={(row) => this.onDelete(row)}
            onSelected={(row) => this.onSelected(row)}
            orderBy={false}
            onRowDoubleClick={(row) => this.onRowDoubleClick(row)}
            headerComponent={Header}
            actionComponent={Action}
            rowComponent={Row}
            onBreadcrumbClick={(folder) => this.onBreadcrumbClick(folder)}
            breadcrumbs={folders}
            onCreateFolderClick={() => this.onCreateFolderClick()}
            onUploadClick={() => this.onUploadClick()}
          />
        </DropZone>
      </div>
    );
  }
}
